























































import http from "@/axios/http-common";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class BarSearchPasien extends Vue {
  pasienItems = [];
  pasien = "";
  isLoading = false;
  pasienSearch = null;
  showData = false;
  hideNoResults = true;
  batasHasil = 100;

  @Watch("pasienSearch")
  changedval(e) {
    this.pasienItems = [];
    this.showData = false;
    this.hideNoResults = true;
  }
  selectPasien(v) {
    console.log("cari pasien", v);
    if (v != null) {
      this.$router.push({
        name: `detail-pasien`,
        params: {
          rm: v.rm,
        },
      });
      this.$nextTick(() => {
        this.pasienSearch = null;
        this.pasien = "";
        this.pasienItems = [];
      });
    }
  }
  getListPasien() {
    this.pasienItems = [];
    if (this.pasienSearch === null) {
      this.pasienItems = [];
    } else {
      this.isLoading = true;
      http
        .getDataParam("/pasien", {
          params: { term: this.pasienSearch },
        })
        .then((res) => {
          this.isLoading = false;
          if (res.data.length > 0) {
            this.showData = false;
            this.hideNoResults = false;
            this.pasienItems = res.data;
          } else {
            this.showData = true;
            this.hideNoResults = false;
            // appModule.NoticeDelayAlert("Data Pasien tidak ditemukan");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  clearCari() {
    this.hideNoResults = true;

    this.pasienItems = [];
  }
}
